module.exports = __webpack_public_path__ + "img/payment-vorkasse.bd0f078.svg";